import {Component} from "@angular/core";
import {AlertController, App, Events, NavController, NavParams, ViewController} from "ionic-angular";
import {Job} from "../shared/job.model";
import {TranslateService} from "@ngx-translate/core";
import {JobService} from "../shared/job.service";
import {ToastService} from "../../../app/core/toast.service";
import {JobsPage} from "../../jobs/jobs.page";
import {RoleService} from "../../../app/core/role.service";
import {JobMenuService} from "./job-menu.service";


@Component({
  templateUrl: 'job-menu.component.html',
})
export class JobMenuComponent {
  job: Job;
  roleSub: any;
  role: string = null;
  buttons;
  private nav: NavController;

  constructor(
    private viewCtrl: ViewController,
    private navParams: NavParams,
    private translate: TranslateService,
    private alertCtrl: AlertController,
    private jobService: JobService,
    private toast: ToastService,
    private events: Events,
    private app: App,
    private roleService: RoleService,
    private jobMenuService: JobMenuService
  ){
    this.job = this.navParams.data.job;
    this.buttons = this.jobMenuService.buttons;

    this.nav = this.app.getRootNav();
  }

  ngOnInit(): void {
    this.roleSub = this.roleService.getRole()
      .subscribe((role) => this.role = role);
  }
  ngOnDestroy(): void {
    this.roleSub.unsubscribe();
  }

  showCancelModal(job) {
    let prompt = this.alertCtrl.create({
      title: this.translate.instant('cancel_job_modal.title'),
      message: this.translate.instant('cancel_job_modal.content'),
      inputs: [
        {
          name: 'reason'
        }
      ],
      buttons: [
        this.translate.instant('global.cancel'),
        {
          text: this.translate.instant('cancel_job_modal.confirm'),
          handler: (inputData) => {
            if (!inputData.reason) {
              return false;
            }
            prompt.dismiss()
              .then(() => this.cancel(job, inputData.reason));
            return false;
          }
        }
      ]
    });
    prompt.present();
  }

  showDeleteModal() {
    let confirm = this.alertCtrl.create({
      title: this.translate.instant('delete_job_modal.title'),
      message: this.translate.instant('delete_job_modal.content'),
      buttons: [
        this.translate.instant('global.cancel'),
        {
          text: this.translate.instant('delete_job_modal.delete'),
          handler: () => {
            confirm.dismiss()
              .then(() => this.deleteJob());
            return false;
          }
        }
      ]
    });
    confirm.present();
  }

  showUnpublishModal() {
    let confirm = this.alertCtrl.create({
      title: this.translate.instant('unpublish_job_modal.title'),
      message: this.translate.instant('unpublish_job_modal.content'),
      buttons: [
        this.translate.instant('global.cancel'),
        {
          text: this.translate.instant('unpublish_job_modal.unpublish'),
          handler: () => {
            confirm.dismiss()
              .then(() => this.unpublish());
            return false;
          }
        }
      ]
    });
    confirm.present();
  }

  republish() {
    this.edit();
    this.resetInterpreterFields();
  }

  editAsNew() {
    this.edit();
    this.job.id = null;
    this.resetInterpreterFields();
  }

  edit() {
    this.job.edit();
    this.viewCtrl.dismiss();
  }

  private resetInterpreterFields() {
    this.job.preferred_interpreter_id = null;
    this.job.preferred_interpreter = null;
    this.job.interpreter_id = null;
    this.job.interpreter = null;
    this.job.rating = null;
    this.job.review = null;
    this.job.cancellation_reason = null;
    this.job.cancelled_by = null;
    this.job.cancelled_by_user = null;
    this.job.cancelled_at = null;
    this.job.rejection_reason = null;
    this.job.rejected_at = null;
    this.job.accepted_at = null;
    this.job.status = null;
  }

  private deleteJob() {
    this.jobService.deleteJob(this.job.id).subscribe(
      success => {
        this.toast.show(success.message);
        this.nav.setPages([{page: JobsPage}])
      }
    );
    this.viewCtrl.dismiss();
  }

  private unpublish() {
    this.jobService.unpublishJob(this.job.id).subscribe(
      success => {
        this.toast.show(success.message);
        this.job.status = 'draft';
        this.job.edit();
      }
    );
    this.viewCtrl.dismiss();
  }

  private cancel(job, reason) {
    this.jobService.cancelJob(job.id, reason)
      .subscribe(
        (res) => {
          this.toast.show(res.message);
          this.events.publish('job:updated');
        }
      );
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/job/job-menu/job-menu.component.ts